import axios from "axios";
import { API_URL } from "./config";

const Axios = axios.create({
  baseURL: API_URL,
  headers: {
    // 추가
    "Access-Control-Allow-Origin": API_URL,
    "Access-Control-Allow-Credentials": "true",
    "Content-Type": "application/json;charset=utf-8",
  },
});
Axios.defaults.withCredentials = true;
export default Axios;

export const AxiosForm = axios.create({
  baseURL: API_URL,
  headers: {
    // 추가
    "Access-Control-Allow-Origin": API_URL,
    "Access-Control-Allow-Credentials": "true",
    "Content-Type": "multipart/form-data",
  },
});
AxiosForm.defaults.withCredentials = true;
